<template>
  <div class="fixed top-4 right-4 z-50 space-y-2 pointer-events-none w-80 max-w-[calc(100vw-2rem)]">
    <transition-group
      enter-active-class="transition duration-150 ease-out"
      enter-from-class="opacity-0 translate-x-2"
      enter-to-class="opacity-100 translate-x-0"
      leave-active-class="transition duration-100 ease-in"
      leave-from-class="opacity-100"
      leave-to-class="opacity-0"
    >
      <div
        v-for="t in toasts"
        :key="t.id"
        :class="['pointer-events-auto rounded-lg shadow-lg border bg-white px-4 py-3 flex items-start gap-3', toneStyle(t.tone).border]"
      >
        <div :class="['shrink-0 h-8 w-8 rounded-full flex items-center justify-center', toneStyle(t.tone).bg, toneStyle(t.tone).text]">
          <svg v-if="t.tone === 'success'" xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7"/></svg>
          <svg v-else-if="t.tone === 'danger'" xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/></svg>
          <svg v-else xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>
        </div>
        <div class="flex-1 min-w-0">
          <p class="text-sm font-medium text-slate-900">{{ t.title }}</p>
          <p v-if="t.message" class="mt-0.5 text-sm text-slate-600">{{ t.message }}</p>
        </div>
        <button class="text-slate-400 hover:text-slate-600 -mr-1" @click="dismiss(t.id)">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/></svg>
        </button>
      </div>
    </transition-group>
  </div>
</template>

<script>
import { toastBus } from '@/services/toast';

const TONES = {
  success: { bg: 'bg-emerald-50',  text: 'text-emerald-600', border: 'border-emerald-200' },
  danger:  { bg: 'bg-red-50',      text: 'text-red-600',     border: 'border-red-200' },
  warning: { bg: 'bg-amber-50',    text: 'text-amber-700',   border: 'border-amber-200' },
  info:    { bg: 'bg-brand-50',    text: 'text-brand-600',   border: 'border-brand-200' },
};

export default {
  name: 'ToastContainer',
  data() {
    return {
      toasts: [],
      seq: 0,
      timers: {},
    };
  },
  methods: {
    toneStyle(tone) { return TONES[tone] || TONES.info; },
    push(t) {
      const id = ++this.seq;
      this.toasts.push({ id, tone: 'info', ...t });
      const ttl = t.ttl ?? 4000;
      if (ttl > 0) {
        this.timers[id] = setTimeout(() => this.dismiss(id), ttl);
      }
    },
    dismiss(id) {
      const idx = this.toasts.findIndex((t) => t.id === id);
      if (idx >= 0) this.toasts.splice(idx, 1);
      if (this.timers[id]) {
        clearTimeout(this.timers[id]);
        delete this.timers[id];
      }
    },
  },
  mounted() {
    toastBus.subscribe(this.push);
  },
  beforeUnmount() {
    toastBus.unsubscribe(this.push);
    Object.values(this.timers).forEach(clearTimeout);
  },
};
</script>
